import React, { useRef, useState } from "react";
import styles from "./ImageInput.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

const ImageUpload: React.FC<InputControlProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    error,
    className,
  } = props;

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (file: File, onChange?: (file: File) => void) => {
    if (file) {
      const url = URL.createObjectURL(file);
      setPreview(url);
      onChange?.(file);
    }
  };

  const renderUpload = (field: any = {}) => (
    <div
      className={combineClasses(
        styles.uploadWrapper,
        error && styles.error,
        className
      )}
      onClick={handleClick}
    >
      {/* Hidden input */}
      <input
        ref={(el) => {
          inputRef.current = el;
          if (field?.ref) field.ref(el);
        }}
        type="file"
        accept="image/*"
        className={styles.hiddenInput}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) handleChange(file, field?.onChange);
        }}
      />

      {/* Preview or Placeholder */}
      {preview ? (
        <img src={preview} alt="preview" className={styles.preview} />
      ) : (
        <div className={styles.placeholder}>
          <svg width="40" height="40" viewBox="0 0 24 24">
            <circle cx="12" cy="8" r="4" stroke="black" fill="none" />
            <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="black" fill="none" />
            <circle cx="18" cy="18" r="3" fill="black" />
            <line x1="18" y1="16" x2="18" y2="20" stroke="white" />
            <line x1="16" y1="18" x2="20" y2="18" stroke="white" />
          </svg>
        </div>
      )}
    </div>
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderUpload(field)}
      />
    );
  } else {
    const field = register?.(name, validations);
    return renderUpload(field);
  }
};

const ImageUploadWithLabelAndError = withLabelAndError(
  ImageUpload as WithLabelAndErrorComponent
);

export default ImageUploadWithLabelAndError;
export { ImageUpload };